/* eslint-disable func-names */
import React from 'react';
import './App.css';
import StampStaircase from './StampStaircase';
import imageCorpus from './images.b64.json';

const App = function () {
  return (
    <StampStaircase imageCorpus={imageCorpus} />
  );
};

export default App;
